import Layout from '@/pages/Layout';

export default [
    {
        path: '/document',
        redirect: 'noredirect',
        component: Layout,
        name: 'document',
        meta: {
            title: '文档中心',
            icon: 'el-icon-folder'
        },
        children: [
            {
                path: 'publicLibrary',
                component: () => import('@/pages/document/PublicLibrary'),
                name: 'publicLibrary',
                id: 'document/publicLibrary',
                meta: {
                    title: '公共文库',
                    icon: 'iconfont icon-other-zhishiwenku bc-custom-menu',
                    color: '#bbf213'
                },
				isMenuWaterfall:true
            },
            {
                path: 'fileTagsTree',
                component: () => import('@/pages/document/FileTagsTree'),
                name: 'fileTagsTree',
                id: 'document/fileTagsTree',
                meta: {
                    title: '文件标签',
                    icon: 'iconfont icon-other-wenjian bc-custom-menu',
                    color: '#ecfa0f'
                },
				isMenuWaterfall:true
            },
            {
                path: 'archiveDesignTitle',
                name: 'archiveDesignTitle',
                id: 'archiveDesignTitle',
                meta: {
                    title: '文档设计',
                    icon: 'iconfont icon-other-wenjian bc-custom-menu',
                    color: '#d2f60b'
                },
                sortOrder: 50,
                isDesign: true,
                isTitle: true,
                isShow: false,
				isMenuWaterfall:true
            },
            {
                pId: 'archiveDesignTitle',
                path: 'archiveTemplate',
                component: () => import('@/pages/document/ArchiveTemplate'),
                name: 'archiveTemplate',
                id: 'document/archiveTemplate',
                meta: {
                    title: '档案模板',
                    icon: 'iconfont icon-other-ziyuan bc-custom-menu',
                    color: '#788319'
                },
                sortOrder: 51,
                isDesign: true,
                isSubMenu: true,
				isMenuWaterfall:true
            },
            {
                path: 'archive/:processInstanceId',
                component: () => import('@/pages/document/Archive'),
                name: 'archive',
                id: 'document/archive/:processInstanceId',
                meta: {
                    title: '档案审核',
                    icon: 'iconfont icon-other-Bomdanganshenheguanli bc-custom-menu',
                    color: '#cef208'
                },
				isMenuWaterfall:true
            },
            {
                path: 'archiveView1',
                component: () => import('@/pages/document/Archive/ArchiveView1'),
                name: 'archive',
                id: 'document/Archive/ArchiveView1',
                meta: {
                    title: '按流程审核',
                    icon: 'table'
                },
				isMenuWaterfall:false
            },
            {
                path: 'archiveView2',
                component: () => import('@/pages/document/Archive/ArchiveView2'),
                // redirect: 'noredirect',
                name: 'archive',
                id: 'document/Archive/ArchiveView2',
                meta: {
                    title: '按档案审核',
                    icon: 'table'
                },
				isMenuWaterfall:false
            },
            {
                path: 'processFiles',
                component: () => import('@/pages/document/ProcessFiles'),
                name: 'processFiles',
                id: 'document/processFiles',
                meta: {
                    title: '流程文件',
                    icon: 'iconfont icon-other-wenjian1 bc-custom-menu',
                    color: '#e6e614'
                },
				isMenuWaterfall:true
            },
            {
                path: 'formFiles',
                component: () => import('@/pages/document/FormFiles'),
                name: 'formFiles',
                id: 'document/formFiles',
                meta: {
                    title: '表单文件',
                    icon: 'iconfont icon-other-zhanghaobianji bc-custom-menu',
                    color: '#f8d113'
                },
				isMenuWaterfall:true
            }
        ]
    }
];



// WEBPACK FOOTER //
// ./src/router/modules/route-document.js